// src/api/commonApi.js
import apiClient from "./axios";

const commonApi = {
  // Existing lightweight dropdowns
  getEmployeeDropdown: async (
    exclude_self = "",
    department = "",
    sub_department = "",
    is_include_superadmins = "",
  ) => {
    const response = await apiClient.get("/employees/dropdown/", {
      params: { exclude_self, department, sub_department,is_include_superadmins },
    });
    return response.data;
  },

  getRequestDropdown: async () => {
    const response = await apiClient.get("/requests/dropdown/");
    return response.data;
  },

  getCanteenDropdown: async () => {
    const response = await apiClient.get("/subcategories/canteen/");
    return response.data;
  },

  // NEW: Issuance Employee Dropdowns (IT & Non-IT)
  getIssuanceEmployeesIT: async () => {
    const response = await apiClient.get("/employees/dropdown/issuance/it/");
    return response.data; // [{ id, name }, ...]
  },

  getIssuanceEmployeesNonIT: async () => {
    const response = await apiClient.get(
      "/employees/dropdown/issuance/non_it/",
    );
    return response.data;
  },

  // NEW: Ticket Employee Dropdowns (IT & Non-IT)
  getTicketEmployeesIT: async () => {
    const response = await apiClient.get("/employees/dropdown/ticket/it/");
    return response.data;
  },

  getTicketEmployeesNonIT: async () => {
    const response = await apiClient.get("/employees/dropdown/ticket/non_it/");
    return response.data;
  },

  // NEW: Stock Lists
  getITStock: async (categoryId = null) => {
    const params = categoryId ? { sub_category__category: categoryId } : {}; // Filtering by category
    const response = await apiClient.get("/stocks/it/", { params });
    return response.data;
  },

  getNonITStock: async (categoryId = null) => {
    const params = categoryId ? { sub_category__category: categoryId } : {}; // Filtering by category
    const response = await apiClient.get("/stocks/non_it/", { params });
    return response.data;
  },

  getInventoryCategories: async () => {
    const response = await apiClient.get("/categories/inventory/");
    return response.data;
  },

  getInventorySubcategories: async (categoryId) => {
    if (!categoryId) return [];
    const response = await apiClient.get(
      `/subcategories/inventory/?category=${categoryId}`,
    );
    return response.data;
  },

  //  getAllInventorySubcategories: async () => {
  //     const response = await apiClient.get("/subcategories/inventory/");
  //     return response.data;
  // },

  // commonApi.js
  getAllInventorySubcategories: async (categoryId) => {
    const response = await apiClient.get("/subcategories/inventory/", {
      params:
        categoryId && categoryId !== "all" ? { category: categoryId } : {},
    });
    return response.data;
  },

  // NEW: Inventory Dropdown (for issuance selection)
  getInventoryDropdown: async () => {
    const response = await apiClient.get("/inventories/dropdown/");
    return response.data; // [{ id, sub_category__name, brand_name, model_no, serial_no }, ...]
  },

  // NEW: Available inventories for a request
  getAvailableInventories: async (requestId) => {
    if (!requestId) return {};
    const response = await apiClient.get(
      `/requests/${requestId}/available-inventories/`,
    );
    return response.data; // Returns object like { "<categoryId>": [inventory items...] }
  },

  // Restore a soft-deleted role
  restoreRole: async (entityType, id) => {
    if (!entityType) throw new Error("Entity type is required");
    if (!id) throw new Error("Entity ID is required");

    const response = await apiClient.post(`/${entityType}/${id}/restore/`);
    return response.data;
  },

  // NEW: Company Dropdown
  getCompanyDropdown: async () => {
    const response = await apiClient.get("/company/dropdown/");
    return response.data; // returns array of { id, name }
  },

  // NEW: Vendor Dropdown
  getVendorDropdown: async () => {
    const response = await apiClient.get("/vendor/dropdown/");
    return response.data; // returns array of { id, name, code }
  },

  // NEW: Department Dropdown
  getDepartmentDropdown: async (parent_null = true, parent = "") => {
    const response = await apiClient.get("/departments/dropdown/", {
      params: { parent_null, parent },
    });
    return response.data; // returns array of { id, name }
  },

  // NEW: Ticket Dropdown
  getTicketDropdown: async () => {
    const response = await apiClient.get("/tickets/dropdown/");
    return response.data; // returns array of { id, ticket_code, status }
  },
  // NEW: Roles Dropdown
  getRoleDropdown: async () => {
    const response = await apiClient.get("/roles/dropdown/");
    return response.data; // [{ id, name }, ...]
  },

  // NEW: Exhibition Dropdown
  getExhibitionDropdown: async () => {
    const response = await apiClient.get("/exhibition/dropdown/");
    return response.data; // returns array of { id, name }
  },

  // NEW: Relation (for forms)
  getEmployeeFieldChoices: async () => {
    // Assuming your backend has an endpoint like this
    // If not → you can use OPTIONS /employees/ directly
    const response = await apiClient.options("/employees/");
    return response.data; // This should contain actions.POST with all fields + choices
  },

  // NEW: Country Dropdown
  getCountryDropdown: async () => {
    const response = await apiClient.get("/country/dropdown/");
    return response.data; // [{ id, name }, ...]
  },

  // NEW: State Dropdown (filtered by country_id)
  getStateDropdown: async (countryId = null) => {
    const params = countryId ? { country: countryId } : {};
    const response = await apiClient.get("/state/dropdown/", { params });
    return response.data; // [{ id, name, country_id, country }, ...]
  },

  // NEW: City Dropdown (filtered by state_id)
  getCityDropdown: async (stateId = null) => {
    const params = stateId ? { state: stateId } : {};
    const response = await apiClient.get("/city/dropdown/", { params });
    return response.data; // [{ id, name, state_id, state, country }, ...]
  },

  // NEW: Employee Location Dropdown
  // Returns: [{ id: uuid, location_name: string }, ...]
  getEmployeeLocationDropdown: async () => {
    const response = await apiClient.get("/employee-location/dropdown/");
    return response.data;
  },

  // NEW: Stock Dropdown
  getStockDropdown: async () => {
    const response = await apiClient.get("/stocks/dropdown/");
    return response.data; // Returns: [{ id, sub_category__name, quantity, sub_category }, ...]
  },

  getExhibitionMembersDropdown: async (exhibition) => {
    const response = await apiClient.get("/exhibition-members/dropdown/", {
      params: { exhibition },
    });
    // console.log("da6ta", response.data)
    return response.data;
  },
};

export default commonApi;
